import { MessageCircle } from 'lucide-react';
import type { FilaDeCartera } from '@/api/cartera.api';
import { Button } from '@/components/ui/Button';
import { Select } from '@/components/ui/Select';
import { OpcionesDeAsignar } from './CeldasDeCliente';

const ALTO = 'min-h-[44px] md:min-h-0';

/**
 * Lo que se hace con el chat de un cliente: abrirlo y asignarlo (a la IA, a mí o a alguien
 * del equipo). Nació en la tanda 5 como una barra fija al pie de «Clientes»; desde la tanda 6
 * es el pie de la ventana de la ficha. Sin datos propios (los pone `useAsignacion`): se prueba
 * con renderToStaticMarkup.
 */
export function AccionesDelContacto({
  fila,
  asignado,
  agentes,
  personas,
  ocupado,
  onAsignar,
  onAbrirChat,
}: {
  fila: FilaDeCartera;
  asignado: string | null;
  agentes: Array<{ id: string; name: string }>;
  /** null: tu rol no puede ver al equipo, y la opción no se ofrece. */
  personas: Array<{ id: string; nombre: string }> | null;
  ocupado: boolean;
  onAsignar: (valor: string) => void;
  onAbrirChat: () => void;
}) {
  return (
    <div role="group" aria-label={`Acciones con ${fila.nombre}`} className="flex w-full flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
      <div className="min-w-0">
        {asignado && <p className="truncate text-sm font-medium text-slate-900 dark:text-slate-100">{asignado}</p>}
        <p className="text-xs text-slate-500 dark:text-slate-400">
          {fila.conversacion
            ? 'Si se lo pasas a una persona, la IA se aparta de este chat.'
            : 'Todavía no ha escrito: el primer toque sale desde Seguimientos.'}
        </p>
      </div>
      {fila.conversacion && (
        <div className="flex shrink-0 items-center gap-2">
          <Button className={ALTO} onClick={onAbrirChat}>
            <MessageCircle className="h-4 w-4" /> Abrir el chat
          </Button>
          <div className="min-w-[9rem] flex-1 sm:w-44 sm:flex-none">
            <Select aria-label="Asignar" value="" disabled={ocupado} onChange={(e) => e.target.value && onAsignar(e.target.value)} className={ALTO}>
              <option value="" disabled>
                Asignar…
              </option>
              {/* Las mismas opciones que la celda «Asignado» de la tabla: una sola lista. */}
              <OpcionesDeAsignar asignables={{ agentes, personas }} />
            </Select>
          </div>
        </div>
      )}
    </div>
  );
}
